import {Component, ElementRef, EventEmitter, HostListener, Inject, Input, Output, Renderer2, ViewChild} from '@angular/core';
import {HeaderRightSideComponent} from "../header-right-side/header-right-side.component";
import {DOCUMENT, NgClass, NgIf} from "@angular/common";
import {Router, RouterLink} from "@angular/router";
import {Subscription} from "rxjs";
import {UserService} from "../../services/user.service";
import {AuthService} from "../../services/auth.service";
import {SubscriptionService} from "../../services/subscription.service";
import {BillingService} from "../../services/billing.service";
import {PopupService} from "../../services/popup.service";
import {Store} from "@ngrx/store";

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    HeaderRightSideComponent,
    NgIf,
    RouterLink,
    NgClass
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

  @Output() dataEmitter: EventEmitter<any> = new EventEmitter();

  @Input() location: string;

  subscription: any;
  user: any;
  isLoading: boolean = false;
  range: string = '10';
  linkedin = '';

  private logoutSubscription: Subscription = new Subscription();
  isLoggedIn: boolean = true;

  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT)
    private document: Document,
    private userService: UserService,
    private authService: AuthService,
    private subscriptionService: SubscriptionService,
    private billingService: BillingService,
    private popupService: PopupService,
    private store: Store,
    private router: Router

  ) {
    this.mediaQuery = window.matchMedia('(max-width: 768px)');

    this.authService.authUser().subscribe(user => {
      this.user = user;
    });

    this.subscriptionService.subscriptionData().subscribe(subscription => {
      this.subscription = subscription;
    });

  }

  sidebarTabs = [
    { id: 1, name: 'Assistant', current: false },
    { id: 2, name: 'Edit', current: false },
    { id: 3, name: 'Notes', current: false },
    { id: 4, name: 'Emails', current: false },
    { id: 5, name: 'CRM', current: false },
  ]
  mediaQuery: MediaQueryList;
  isMenuOpen = false;
  isUserOpen = false;
  isDarkMode = false;

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }
  isMobile(): boolean {
    return this.mediaQuery.matches;
  }

  @ViewChild('inputElement') inputElement: ElementRef;

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
      this.inputElement.nativeElement.focus();
      event.preventDefault();
    }
  }
}
